import React, { useState } from 'react'

const SocialMediaLinks = ({
  data,
  index,
  setPersonalAndBackGroundInfo,
  labels,
  question,
  personalAndBackGroundInfo,
  setChangesMade,
}) => {
  const [errors, setErrors] = useState({
    instaLink: '',
    twitterLink: '',
    youtubeChannelLink: '',
  })

  const validateUrl = (url, type) => {
    let pattern
    switch (type) {
      case 'instaLink':
        pattern = /^(https?:\/\/)?(www\.)?instagram\.com\/.*$/
        break
      case 'twitterLink':
        pattern = /^(https?:\/\/)?(www\.)?(twitter\.com|x\.com)\/.*$/
        break
      case 'youtubeChannelLink':
        pattern = /^(https?:\/\/)?(www\.)?youtube\.com\/.*$/
        break
      default:
        return false
    }

    return pattern.test(url)
  }

  const handleLinkChange = (key, value) => {
    const newValue = value.trim()
    const newErrors = { ...errors }

    newErrors[key] = ''
    const answerItemsEn = [{ ...data, [key]: newValue ? [newValue] : null }]
    const dataTemp = [...personalAndBackGroundInfo]
    if (dataTemp[index]) {
      dataTemp[index].answerItems_En = answerItemsEn
      setPersonalAndBackGroundInfo(dataTemp)
    } else {
      console.error(`${labels[0]} is not a valid key in dataTemp`)
    }

    if (validateUrl(newValue, key)) {
      setChangesMade(true)
    } else if (newValue === '') {
      setChangesMade(true)
    } else {
      setChangesMade(false)
      newErrors[key] = `Please enter a valid ${
        key === 'instaLink' ? 'Instagram' : key === 'twitterLink' ? 'Twitter' : 'YouTube'
      } URL.`
    }

    setErrors(newErrors)
  }

  return (
    <div>
      <h6>
        {question}/{labels[0]}
      </h6>
      <div>
        <strong>Instagram:</strong>
        <input
          type='text'
          className='form-control'
          value={data.instaLink || ''}
          onChange={e => handleLinkChange('instaLink', e.target.value)}
        />
        {errors.instaLink && <p className='text-danger'>{errors.instaLink}</p>}
      </div>
      <div>
        <strong>Twitter:</strong>
        <input
          type='text'
          className='form-control'
          value={data.twitterLink || ''}
          onChange={e => handleLinkChange('twitterLink', e.target.value)}
        />
        {errors.twitterLink && <p className='text-danger'>{errors.twitterLink}</p>}
      </div>
      <div>
        <strong>YouTube:</strong>
        <input
          type='text'
          className='form-control'
          value={data.youtubeChannelLink || ''}
          onChange={e => handleLinkChange('youtubeChannelLink', e.target.value)}
        />
        {errors.youtubeChannelLink && <p className='text-danger'>{errors.youtubeChannelLink}</p>}
      </div>
    </div>
  )
}

export default SocialMediaLinks
